<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editPassword.txt1')}}</span>
        <span>{{$t('editPassword.txt2')}} / {{id?$t('addUser.txt1'):$t('addUser.txt2')}}</span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn ml20" @click="onBack">{{$t('authoritySettings.txt5')}}</div>
      </div>
    </div>
    <!-- <div class="searchBox relative">
      <div class="fl flex">
        <div class="btnC activedBtn mr2" @click="handleAdd">
          <img src="@/assets/picture/icon/adduser_icon.png" width="20"/>
          <span class="btn-txt">添加用户</span>
        </div>
        <el-upload
        :headers="importHeaders"
        class="avatar-uploader"
        action="http://47.117.178.219:8080/user/info/import"
        :show-file-list="false"
        :on-exceed="handleAvatarExceed"
        :on-success="handleAvatarSuccess">
        <div class="btnC addBtn mr2" @click="handleUpload">
          <img src="@/assets/picture/icon/importusers_icon.png" width="20"/>
          <span class="btn-txt">导入用户</span>
        </div>
      </el-upload>
        
        <div class="btnC addBtn mr2" @click="handleDownload">
          <img src="@/assets/picture/icon/exportusers_icon.png" width="20"/>
          <span class="btn-txt">导出模板</span>
        </div>
      </div> -->
     <!--  <div class="fr rightBox">
        <div class="searchSubBox flex">
          <div class="flex searchSubBox">
            <span class="labelTxt">手机号:</span>
            <el-input v-model="queryInfo.mobile" placeholder="请输入"></el-input>
          </div>
          <div class="flex searchSubBox">
            <span class="labelTxt">用户名:</span>
            <el-input v-model="queryInfo.userName" placeholder="请输入"></el-input>
          </div>
          <div class="flex searchSubBox">
            <span class="labelTxt">真实姓名:</span>
            <el-input v-model="queryInfo.realName" placeholder="请输入"></el-input>
          </div>
          <div class="btnC activedBtn" @click="handleSearch">
            <span class="btn-txt">查询</span>
          </div>
        </div>
      </div> -->
    <!-- </div> -->
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{id?$t('addUser.txt1'):$t('addUser.txt2')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="resetAddUser('editForm')">{{$t('editPassword.txt3')}}</div>
          <div class="searchBtn" @click="confirmAddUser('editForm')">{{$t('uDialog.txt1')}}</div>
        </div>
      </div>
      <div class="editForm">
        <el-form ref="editForm" :model="addUserFromData" :rules="addUserRules">
          <el-row  :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('addUser.txt5')" prop="userName">
                <el-input :placeholder="$t('addUser.txt6')" v-model="addUserFromData.userName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('addUser.txt7')" prop="password">
                <el-input :placeholder="$t('addUser.txt6')" v-model="addUserFromData.password" show-password></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('addUser.txt9')" prop="realName">
                <el-input :placeholder="$t('addUser.txt6')" v-model="addUserFromData.realName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="E-mail" prop="email">
                <el-input :placeholder="$t('addUser.txt6')" v-model="addUserFromData.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('addUser.txt8')" prop="companyName">
                <el-input :placeholder="$t('addUser.txt6')" v-model="addUserFromData.companyName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('addUser.txt10')" prop="companyAddress">
                <el-input :placeholder="$t('addUser.txt6')" v-model="addUserFromData.companyAddress"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('addUser.txt11')" prop="validityDate">
                <el-date-picker
                  v-model="validityDate"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  :start-placeholder="$t('addUser.txt12')"
                  :end-placeholder="$t('addUser.txt13')">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    
  </div>
</template>

<script>
  let mytoken = window.sessionStorage.getItem("token");
  import { crytoLogin } from "@/plugins/index.js";
  import axios from "axios";
  import qs from 'qs';
  export default {
    data() {
      const checkEmail=(rule, value, callback) => {
        let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
          setTimeout(() => {
              if(value && !reg.test(value)){
                  callback(new Error(this.$t('addUser.txt14')));
              }else{
                  callback()
              }
          }, 1000);
      }
      return {
        loading: false,
        time:'',
        addUserForm:{},//添加用户参数
        dataList: [],
        total: 0,
        id:'',
        validityDate:[],//有效期数组
        addUserFromData:{
          roleId:window.sessionStorage.getItem("roleId"),
        },//用户新增表单参数
        // 添加用户规则
        addUserRules: {
          userName: [
            { required: true, message: this.$t('addUser.txt15'), trigger: 'blur' },
          ],
          password:[
            { required: true, message: this.$t('addUser.txt16'), trigger: 'blur' },
          ],
          email: [
            { validator: checkEmail, trigger: 'blur' }
          ]
        }
      };
    },
    created() {
      this.id = this.$route.query.id?this.$route.query.id:'';
      if(this.id){
        this.addUserFromData.userId = this.id;
      }
    },
    methods: {
      onBack(){
        this.$router.go(-1);
      },
      // 添加编辑用户操作
      confirmAddUser(formName) {
       this.$refs[formName].validate((valid) => {
         if (valid) {
          this.addUserFromData.effectiveDate = this.validityDate[0];
          this.addUserFromData.expiredDate = this.validityDate[1];
           this.add();
         } else {
           console.log('error submit!!');
           return false;
         }
       });
      },
      // 取消新增用户弹窗
      resetAddUser(formName) {
        this.$refs[formName].resetFields();
        this.onBack();
      },
      // 用户管理添加/修改
      async add(){
        this.addUserFromData.password = crytoLogin(this.addUserFromData.password).rsaData;
        const { data: res } = await this.$http.post("/user/info/add",this.addUserFromData);
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.onBack();
      },
    },
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .userPage{
    /deep/ .el-upload__input{
      display: none !important;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .w350{
      width: 350px;
    }
    .searchUserBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      /deep/ .el-input__inner{
        border:1px solid #C0C0C0;
        border-right:none;
      }
      /deep/ .el-input-group__append{
        border:1px solid #C0C0C0;
        border-left:none;
        padding:0;
        background: #fff;
      }
      /deep/ .el-input-group__append button.el-button{
        padding:0;
        width: auto;
        margin-right: 1.1rem;
      }
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    .editForm{}
     /deep/  .el-date-table td.today span{
        color: #fff;
        background: #1B3B7C;
        border-radius: 100%;
    }
    /deep/ .el-date-table td.end-date span,/deep/ .el-date-table td.start-date span{
        background: #1B3B7C !important;
    }

    }

</style>
